(() => {
  if(window.PJCollectionCards)return;
  window.PJCollectionCards=true;
  const cache=new Map();
  const apply=(img,result)=>{
    if(!result)return;
    img.style.setProperty('--pj-image-scale',result.scale);
    img.style.setProperty('--pj-image-x',result.x+'%');
    img.style.setProperty('--pj-image-y',result.y+'%');
    img.dataset.pjFramed='true';
  };
  async function frame(img){
    if(img.dataset.pjMeasuring)return;
    img.dataset.pjMeasuring='true';
    if(!img.complete)await new Promise(resolve=>{img.addEventListener('load',resolve,{once:true});img.addEventListener('error',resolve,{once:true});});
    if(!img.naturalWidth)return;
    const url=img.currentSrc||img.src;
    if(cache.has(url)){apply(img,await cache.get(url));return;}
    const task=(async()=>{
      try{
        const probe=new Image();probe.crossOrigin='anonymous';probe.src=url;await probe.decode();
        const n=160,canvas=document.createElement('canvas');canvas.width=n;canvas.height=n;
        const ctx=canvas.getContext('2d',{willReadFrequently:true});ctx.fillStyle='#fff';ctx.fillRect(0,0,n,n);
        const fit=Math.min(n/probe.naturalWidth,n/probe.naturalHeight),w=probe.naturalWidth*fit,h=probe.naturalHeight*fit;
        ctx.drawImage(probe,(n-w)/2,(n-h)/2,w,h);
        const data=ctx.getImageData(0,0,n,n).data;
        const bright=(x,y)=>{const i=(y*n+x)*4;return Math.min(data[i],data[i+1],data[i+2])>240;};
        if(![[4,4],[155,4],[4,155],[155,155]].every(([x,y])=>bright(x,y)))return null;
        let x0=n,y0=n,x1=0,y1=0,count=0;
        for(let y=2;y<n-2;y++)for(let x=2;x<n-2;x++){
          const i=(y*n+x)*4;
          if(Math.min(data[i],data[i+1],data[i+2])<220){x0=Math.min(x0,x);x1=Math.max(x1,x);y0=Math.min(y0,y);y1=Math.max(y1,y);count++;}
        }
        if(count<70||x0<3||y0<3||x1>n-4||y1>n-4)return null;
        const extent=Math.max(x1-x0+1,y1-y0+1)/n;
        const scale=Math.min(3.5,.78/extent);
        return {scale:scale.toFixed(4),x:((.5-(x0+x1+1)/2/n)*scale*100).toFixed(3),y:((.5-(y0+y1+1)/2/n)*scale*100).toFixed(3)};
      }catch{return null;}
    })();
    cache.set(url,task);apply(img,await task);
  }
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){observer.unobserve(entry.target);frame(entry.target);}}),{rootMargin:'250px'});
  const scan=()=>document.querySelectorAll('[data-pj-collection-section] .card__media img:not([data-pj-observed])').forEach(img=>{img.dataset.pjObserved='true';observer.observe(img);});
  new MutationObserver(scan).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',scan);scan();
})();
